/**
 * Formats Java Instant into a local string representation
 * @param instant
 * @returns {string}
 */
export function formatInstant(instant) {
  return new Date(instant).toLocaleString();
}
